export default __webpack_public_path__ + "3cd786652b8a2e9d41f210cb1a527ff6.ttf";